import React, {Component} from "react";
import CancelledOrdersTableHeader from "./CancelledOrdersTableHeader";
import CancelledOrdersTableRow from "./CancelledOrdersTableRow";
import CancelledOrdersTableBottom from "./CancelledOrdersTableBottom";
import {ITEM_COUNT_PER_PAGE, RESOURCE_BASE_URL} from "../../../../../configuration";
import axios from "axios";
import {FormattedMessage} from "react-intl";
import AllSalesBottom from "../../ViewAllSales/AllSalesBottom/AllSalesBottom";
import CancelledOrdersHeader from "./CancelledOrdersHeader";

class CancelledOrdersTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orders: [],
            totalItemCount: 0,
            activePage: 1,
            allOrderCount: 0,
            dollarAmount: 0.0,
            totalAmount: 0.0,
            filterFrom: "",
            filterTo: "",
            searchData: {
                page: 0,
                size: 5
            },
            searchText: "empty",
        };
        this.handlePageChange = this.handlePageChange.bind(this);
        this.getCancelledOrders = this.getCancelledOrders.bind(this);
        this.searchCancelledOrdersByBatchNumber = this.searchCancelledOrdersByBatchNumber.bind(this);
        this.onSearchInputChange = this.onSearchInputChange.bind(this);
    }

    handlePageChange = (pageNumber) => {

        this.setState({activePage: pageNumber});

        let offset = (pageNumber - 1) * ITEM_COUNT_PER_PAGE;

        let searchData = {...this.state.searchData};
        searchData.page = pageNumber - 1;
        this.setState({
            searchData
        }, () => this.searchCancelledOrdersByBatchNumber())
    };

    componentDidMount() {
        this.searchCancelledOrdersByBatchNumber();
    }

    onSearchInputChange = (event) => {
        if (event.target.value === "") {
            this.setState({searchText: "empty"}, () => this.searchCancelledOrdersByBatchNumber())
        } else {
            this.setState({searchText: event.target.value}, () => this.searchCancelledOrdersByBatchNumber())
        }
    };

    searchCancelledOrdersByBatchNumber = () => {

        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/order/cancelled/' + this.state.searchText + '?offset=' + this.state.searchData.page + '&limit=' + this.state.searchData.size, axiosConfig)
            .then((res) => {
                this.setState({
                    orders: res.data.orders.content,
                    totalItemCount: res.data.rowCount
                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });

    };

    getCancelledOrders = (offset, limit) => {

        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/orders/cancelled?offset=' + offset + '&limit=' + limit, axiosConfig)
            .then((res) => {
                this.setState({
                    orders: res.data.orders.content,
                    totalItemCount: res.data.rowCount
                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });

    };

    render() {
        let no = 1 + ((this.state.activePage - 1) * ITEM_COUNT_PER_PAGE);
        return (
            <div>
                <div className="admin-table-width">
                    <div className="title-1 text-align-left">
                        注文のキャンセル

                    </div>
                    <hr/>
                    <br/>
                    <CancelledOrdersTableHeader getCancelledOrders={this.getCancelledOrders}
                                                orders={this.state.orders}
                                                totalAmount={this.state.totalAmount}
                                                allOrderCount={this.state.allOrderCount}
                                                dollarAmount={this.state.dollarAmount}
                                                onSearchInputChange={this.onSearchInputChange}/>
                   <div className="admin-tables">

                       <div className="admin-table-row-content">
                           <table className="table table-bordered table-all-orders-resp">
                               <CancelledOrdersHeader/>

                               <tbody>
                               {this.state.orders.length !== 0 ?

                                   this.state.orders.map(orders => {
                                       return <CancelledOrdersTableRow key={orders.id} no={no++} orders={orders}
                                                                       getCancelledOrders={this.getCancelledOrders}/>
                                   }) : <tr><td colSpan={6}>
                                       <div className="text-center"><br/><br/><FormattedMessage id="app.order.all.no-records"
                                                                                                defaultMessage="No Records Found"
                                                                                                description=""/></div>
                                   </td></tr>
                               }
                               </tbody>
                           </table>


                       </div>
                   </div>
                </div>
                <CancelledOrdersTableBottom handlePageChange={this.handlePageChange}
                                            totalItemsCount={this.state.totalItemCount}
                                            activePage={this.state.activePage}
                                            itemsCountPerPage={ITEM_COUNT_PER_PAGE}/>

            </div>
        )
    }
}

export default CancelledOrdersTable;



// WEBPACK FOOTER //
// ./src/components/Admin/Sales/CancelledOrder/CancelledOrdersTable/CancelledOrdersTable.js